document.addEventListener("DOMContentLoaded", () => {
  (async () => {
    try {
      // Form the URL with query parameters
      const url =
        `${window.Shopify.routes.root}browsing_context_suggestions.json` +
        `?country[enabled]=true` +
        `&country[exclude]=${window.Shopify.country}` +
        `&language[enabled]=true` +
        `&language[exclude]=${window.Shopify.language}`;

      // Perform the fetch request
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Parse the JSON response
      const data = await response.json();

      // Get the detected country handle
      const detectedCountryHandle = data.detected_values?.country?.handle;

      // Determine the country code to use
      let countryCode;
      if (detectedCountryHandle === "AT") {
        countryCode = "AT";
      } else if (detectedCountryHandle === "DE") {
        countryCode = "DE";
      } else {
        countryCode = ""; // No change or fallback
      }

      // Update a hidden input field or element to store the country code
      const countryCodeInput = document.getElementById("detected-country-code");
      if (countryCodeInput) {
        countryCodeInput.value = countryCode;
      }

      // Trigger a change event if needed
      countryCodeInput.dispatchEvent(new Event("change"));
    } catch (error) {
      console.error("Error fetching or processing data:", error);
    }
  })();
});
